import { useFlags } from 'launchdarkly-react-client-sdk'

export function useInstantBundleData(): boolean {
  const { releaseInstantBundleToggleDataPointsVendorPortal } = useFlags()
  return releaseInstantBundleToggleDataPointsVendorPortal
}
